import { render } from "./ResponsiveTable.vue?vue&type=template&id=82fe486c&lang=pug"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js"

import "./ResponsiveTable.vue?vue&type=style&index=0&id=82fe486c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__